export default "__VITE_ASSET__cB2nH331__"